import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { AnchorLink } from '../components'
import './Header.scss'

const Header = ({ visible, scrolled, toggle, links, currentLocale }) => (
  <header className={`header ${visible ? 'open' : ''} ${scrolled ? 'scrolled' : ''}`}>
    <div className="container">
      <div>
        <AnchorLink to="/" activeClassName="active">
          <img src="/images/logo.png" alt="stadyum logo" />
        </AnchorLink>
      </div>
      <nav>
        {links.map((link, i) => (
          <AnchorLink
            to={link.url}
            key={i}
            className={link.callout ? 'call-to-action' : ''}
            onClick={toggle}
          >
            {link.text}
          </AnchorLink>
        ))}
        <div className="languages">
          <a href="/" to="/" className={currentLocale === 'cs' ? 'active' : ''}>
            cs
          </a>
          <span className="divider">|</span>
          <a href="/sk" to="/sk" className={currentLocale === 'sk' ? 'active' : ''}>
            sk
          </a>
          <span className="divider">|</span>
          <a href="/en" to="/en" className={currentLocale === 'en' ? 'active' : ''}>
            en
          </a>
        </div>
      </nav>
      <button className="toggle" onClick={toggle}>
        <span />
        <span />
        <span />
      </button>
    </div>
  </header>
)

Header.defaultProps = {
  scrolled: false,
}
Header.propTypes = {
  visible: React.PropTypes.bool.isRequired,
  toggle: React.PropTypes.func.isRequired,
  links: React.PropTypes.array.isRequired,
  scrolled: React.PropTypes.bool,
  currentLocale: React.PropTypes.string.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/browser/app/Header.js